// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31upP","colBig":"styles_colBig__2gxht","colSmall":"styles_colSmall__zJ-mz","shopifyNameWrapper":"styles_shopifyNameWrapper__1UR5-"};